import { myFetch, HttpMethod } from "./baseService";

export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

export interface ObtenerAsambleasRequest {
  "unidad residencial codigo": string;
  codigo?: string;
}

export interface AsambleaRecord {
  asa_codigo: number | string;
  asa_unidad_residencial: string;
  asa_unidad_residencial_nombre: string;
  asa_fecha_apertura: string;
  asa_fecha_inicio: string;
  asa_fecha_cierre: string;
  asa_llave: string;
  asa_administrador: string;
  asa_administrador_nombre: string;
  asa_moderador: string;
  asa_moderador_nombre: string;
  asa_titulo: string;
  asa_descripcion: string;
  asa_estatus: string;
  asa_estatus_nombre: string;
}

export interface InsertarAsambleaRequest {
  unidad_residencial_codigo: string;
  usuario_administrador: string;
  usuario_moderador: string;
  titulo: string;
  descripcion: string;
  estatus_codigo?: string;
}

export interface ModificarAsambleaRequest {
  codigo: string;
  unidad_residencial_codigo: string;
  usuario_administrador: string;
  usuario_moderador: string;
  titulo: string;
  descripcion: string;
}

export interface ModificarEstatusAsambleaRequest {
  codigo: string;
  unidad_residencial_codigo: string;
  usuario_administrador: string;
  estatus_codigo: string;
}

export const obtenerAsambleas = async (payload: ObtenerAsambleasRequest) => {
  const envelope = await myFetch<ApiEnvelope<AsambleaRecord[]>>(
    "asamblea/ObtenerTodos",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export const insertarAsamblea = async (payload: InsertarAsambleaRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "asamblea/Insertar",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export const modificarAsamblea = async (payload: ModificarAsambleaRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "asamblea/modificar",
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export const modificarEstatusAsamblea = async (payload: ModificarEstatusAsambleaRequest) => {
  const envelope = await myFetch<ApiEnvelope<any>>(
    "asamblea/Modificar_Estatus",
    HttpMethod.POST,
    payload
  );

  return envelope;
};
